import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Application from "./pages/Application";

function App() {
  return (
    <div className="App">
      <Application />
    </div>
  );
}

export default App;
